import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import { usePipelineContext } from '@/context/pipelineContext';

const DataGridProspectStage = ({ stage }) => {
	const { stages, isLoading } = usePipelineContext(process.env.REACT_APP_PIPELINE_PROSPECTS);

	const stageLabel =
		stages?.find((s) => s.stageId === stage || s.id === stage)?.label ?? stage ?? '';

	return isLoading ? (
		<Skeleton variant='text' width='5em' />
	) : (
		<Typography variant='inherit'>{stageLabel}</Typography>
	);
};

export default DataGridProspectStage;
